import { render, staticRenderFns } from "./AdvProductPageButton.vue?vue&type=template&id=ba5c3876&scoped=true"
import script from "./AdvProductPageButton.vue?vue&type=script&lang=js"
export * from "./AdvProductPageButton.vue?vue&type=script&lang=js"
import style0 from "./AdvProductPageButton.vue?vue&type=style&index=0&id=ba5c3876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5c3876",
  null
  
)

export default component.exports